export function launchConfetti() {
    const count  = 30 + Math.floor(Math.random() * 21);
    const colors = [
        'rgba(255, 175, 69, 1)',
        'rgba(255, 91, 132, 1)',
        'rgba(255, 91, 132, 1)',
    ];

    const wrap = document.createElement('div');
    wrap.style.cssText = 'position:fixed;inset:0;pointer-events:none;overflow:hidden;z-index:9999;';
    document.body.appendChild(wrap);

    const originX = window.innerWidth / 2;
    const originY = window.innerHeight;
    const pieces  = [];

    for (let i = 0; i < count; i++) {
        const size        = 20 + Math.random() * 44;
        const color       = colors[Math.floor(Math.random() * colors.length)];
        const initOpacity = 0.7 + Math.random() * 0.25;
        const rotation    = Math.random() * 360;
        const rotSpeed    = (Math.random() - 0.5) * 10;
        const speed       = 15 + Math.random() * 15;
        const spread      = (Math.random() - 0.5) * Math.PI * 0.75;
        const vx          = Math.sin(spread) * speed;
        const vy          = -Math.cos(spread) * speed;

        const el = document.createElement('div');
        el.style.cssText = `position:absolute;top:0;left:0;width:${size}px;height:${size}px;background:${color};will-change:transform,opacity;`;
        wrap.appendChild(el);

        pieces.push({ el, x: originX, y: originY, vx, vy, rotation, rotSpeed, initOpacity, size });
    }

    const gravity  = 0.35;
    const duration = 5000;
    const t0       = performance.now();

    function tick(now) {
        const t = Math.min((now - t0) / duration, 1);

        pieces.forEach(p => {
            p.vy        += gravity;
            p.x         += p.vx;
            p.y         += p.vy;
            p.rotation  += p.rotSpeed;
            p.el.style.opacity   = p.initOpacity * (1 - t);
            p.el.style.transform = `translate(${p.x - p.size / 2}px,${p.y - p.size / 2}px) rotate(${p.rotation}deg)`;
        });

        if (t < 1) {
            requestAnimationFrame(tick);
        } else {
            wrap.remove();
        }
    }

    requestAnimationFrame(tick);
}
